module.exports = __webpack_public_path__ + "img/img-1-1000x900.63696998.jpg";